import PageHeader from '@casops/components/layout/page-header/PageHeader';
import StandardPage from '@casops/templates/standard-page/StandardPage';
import { Outlet, useMatch } from 'react-router-dom';
import { QueryTag, TagList } from '@casops/store/api';
import { TagDescription } from '@reduxjs/toolkit/query';
import styles from './HomePage.module.scss';
import { useGetSiteName } from '@casops/store/slices/settingsSlice';
import { GEOFENCE_SUB_ROUTE } from '@casops/navigation';
import SiteMap from '@casops/components/maps/site-map/SiteMap';
import classNames from 'classnames';
import TracksBar from './geofence/components/tracks-bar/TracksBar';

const tagsToClearOnRefresh: TagDescription<QueryTag>[] = [
  { type: QueryTag.Geofence, id: TagList },
  { type: QueryTag.AssetRegistered, id: TagList },
  { type: QueryTag.AssetGroup, id: TagList },
  { type: QueryTag.GeofenceStyle, id: TagList },
  { type: QueryTag.GeofenceArea, id: TagList },
  { type: QueryTag.GeofenceSpeedLimit, id: TagList },
  { type: QueryTag.GeofenceHoldTime, id: TagList },
  { type: QueryTag.GeofenceGeoJson, id: TagList },
  QueryTag.SettingsUi,
];

export const HomePage = () => {
  const siteName = useGetSiteName();
  const geofenceMatch = useMatch(GEOFENCE_SUB_ROUTE);
  const isGeofenceSubRoute = Boolean(geofenceMatch);

  return (
    <StandardPage
      header={
        <PageHeader
          title={siteName}
          tagsToClearOnRefresh={tagsToClearOnRefresh}
          isRefreshDisabled={isGeofenceSubRoute}
        />
      }
    >
      <div
        className={classNames(styles.container, {
          [styles['container--formView']]: isGeofenceSubRoute,
        })}
      >
        <div className={styles.mapView}>
          <div className={styles.mapContainer}>
            <SiteMap />
          </div>
          {isGeofenceSubRoute && <TracksBar />}
        </div>

        <div className={styles.subRoutes}>
          <Outlet />
        </div>
      </div>
    </StandardPage>
  );
};

export default HomePage;
